enum Actions {
  // action types
  ADD_BODY_CLASSNAME = 'addBodyClassName',
  REMOVE_BODY_CLASSNAME = 'removeBodyClassName',
  ADD_BODY_ATTRIBUTE = 'addBodyAttribute',
  REMOVE_BODY_ATTRIBUTE = 'removeBodyAttribute',
  ADD_CLASSNAME = 'addClassName',
  VERIFY_AUTH = 'verifyAuth',
  REFRESH_TOKEN = 'refreshToken',
  AUTO_REFRESH_TOKEN = 'autoRefreshToken',
  LOGIN = 'login',
  LOGOUT = 'logout',
  REGISTER = 'register',
  UPDATE_USER = 'updateUser',
  FORGOT_PASSWORD = 'forgotPassword',
  SET_BREADCRUMB_ACTION = 'setBreadcrumbAction',
  SET_BREADCRUMB_ITEMS_ACTION = 'setBreadcrumbItemsAction',
  SET_THEME_MODE_ACTION = 'setThemeModeAction',
  LOAD_ABILITIES = 'loadAbilities',
  SYNC_ABILITIES = 'syncAbilities',
  REFRESH_ABILITIES = 'refreshAbilities',
  RESET_ABILITIES = 'resetAbilities',
  INIT_USER_SYSTEM_SETTINGS = 'initUserSystemSettings',
  SAVE_USER_SYSTEM_SETTINGS = 'saveUserSystemSettings',
}

enum Mutations {
  // mutation types
  SET_CLASSNAME_BY_POSITION = 'appendBreadcrumb',
  PURGE_AUTH = 'logOut',
  SET_AUTH = 'setAuth',
  SET_USER = 'setUser',
  SET_USER_AVATAR = 'setUserAvatar',
  SET_PASSWORD = 'setPassword',
  SET_ERROR = 'setError',
  SET_BREADCRUMB_MUTATION = 'setBreadcrumbMutation',
  SET_BREADCRUMB_LINKS_MUTATION = 'setBreadcrumbLinksMutation',
  SET_LAYOUT_CONFIG = 'setLayoutConfig',
  RESET_LAYOUT_CONFIG = 'resetLayoutConfig',
  OVERRIDE_LAYOUT_CONFIG = 'overrideLayoutConfig',
  OVERRIDE_PAGE_LAYOUT_CONFIG = 'overridePageLayoutConfig',
  SET_YEAR = 'setYear',
  REMOVE_YEAR = 'removeYear',
  SET_FILTER_DATE_RANGE = 'setFilterDateRange',
  SET_WORKING_YEARS = 'setWorkingYears',
  SET_THEME_MODE_MUTATION = 'setThemeModeMutation',
  // App Configuration mutations
  SET_APP_SETTINGS = 'setAppSettings',
  MERGE_APP_SETTINGS = 'mergeAppSettings',
  RESET_APP_SETTINGS = 'resetAppSettings',
  SET_APP_SETTING = 'setAppSetting',
  SET_ABILITIES = 'setAbilities',
  SET_ABILITIES_LOADED = 'setAbilitiesLoaded',
  SET_USER_ID = 'setUserId',
  SET_VERSION = 'setVersion',
  SET_DON_VI_OPTIONS = 'setDonViOptions',
  SET_ABILITIES_ID_DON_VI = 'setAbilitiesIdDonVi',
  SET_USER_SYSTEM_SETTINGS = 'setUserSystemSettings',
  SET_USER_SYSTEM_TEN_DON_VI = 'setUserSystemTenDonVi',
}

export { Actions, Mutations };
